export default __webpack_public_path__ + "img/jtc/jtc8_700.jpg";